import { getStyle } from './getStyle';
import { Image, Text, View } from '@react-pdf/renderer';
import * as React from 'react';
import { SectionStyle } from '../../../../helpers/SectionStyle';

export function getHeader(logoURL: string, unternehmen: string, jahr: number): JSX.Element {
    const etoolLogo = require('../../../../img/Logo.jpg');
    const sectionId: string = typeof SectionStyle.curPrintSectionId === 'number'
        ? SectionStyle.getCurrentId(true)
        : SectionStyle.getCurrentId();
    const logoSection = sectionId ? require(`../../../../img/logo_section_${sectionId}.jpg`) : etoolLogo;

    return (
        <View fixed style={{ ...getStyle('header') }}>
            <View style={{ display: 'flex', flexDirection: 'column' }}>
                <Text style={{ marginBottom: '5pt' }}>{unternehmen || ''}</Text>
                <Text style={{ marginBottom: '5pt' }}>Nachhaltigkeitsbericht {jahr || ''} (VSME)</Text>
            </View>
            <View style={{ display: 'flex', flexDirection: 'row' }}>
                {logoURL &&
                    <Image src={logoURL} style={getStyle('headerLogo')} />
                }
                <Image src={logoSection} style={getStyle('headerLogo')} />
            </View>
        </View>
    );
}
